import React from 'react'
import { Button, getImgProps } from '@superhi/design'

import events from 'src/events'
import EmailModal from 'src/components/EmailModal'
import { useSession } from 'src/api'

type Props = {
  syllabusUrl: string
  courseMailchimpTag: string
  emailModalImageUrl: string
}

const GetCourseSyllabus: React.FC<React.PropsWithChildren<Props>> = ({
  syllabusUrl,
  courseMailchimpTag,
  emailModalImageUrl,
}) => {
  const [isLoggedIn] = useSession()
  const [modalIsVisible, setModalIsVisible] = React.useState(false)
  const imageProps = React.useMemo(
    () =>
      getImgProps(emailModalImageUrl, {
        small: 1,
        medium: 35,
        large: 30,
        xlarge: 30,
      }),
    [emailModalImageUrl],
  )

  const handleEmailEntered = (email: string) => {
    events.emailSubmitted({ email })
  }

  return (
    <>
      <Button
        href={isLoggedIn ? syllabusUrl : undefined}
        onClick={() => (!isLoggedIn ? setModalIsVisible(true) : undefined)}
        isExternal={isLoggedIn}
      >
        View the course syllabus
      </Button>

      {modalIsVisible && (
        <EmailModal
          title="View the course syllabus"
          subtitle="After entering your email address below, you'll be able to view straight away."
          successMessage="Happy reading!"
          image={imageProps}
          imageFit="cover"
          imageBackgroundColor="WARM_BLUE_30"
          onClose={() => setModalIsVisible(false)}
          downloads={
            <Button href={syllabusUrl} isExternal>
              Click to view
            </Button>
          }
          leadTag={`${courseMailchimpTag}-syllabus-downloaded`}
          onEmailEntered={handleEmailEntered}
        />
      )}
    </>
  )
}

export default GetCourseSyllabus
